// @flow
import {
  Fetus,
  Ent,
  Heart,
  Brain,
  Ribbon,
  Kidney,
  Ortho,
  Spine,
  BoneMarrow,
  Liver,
  Lungs,
  Intestine,
  Eye,
  Hair,
  Hernia,
  Fat,
  Unknown,
  Cosmetic
} from '@images/svg';
import type { PropsIllnessFlow, PropsFlowButton } from './types';

export const BUTTONS = ({ t }: PropsIllnessFlow): Array<PropsFlowButton> => [
  {
    label: t('Illness.brain'),
    icon: Brain,
    value: 'brain'
  },
  {
    label: t('Illness.bone_marrow'),
    icon: BoneMarrow,
    value: 'bone_marrow'
  },
  { label: t('Illness.cancer'), icon: Ribbon, value: 'cancer' },
  {
    label: t('Illness.cosmetic'),
    icon: Cosmetic,
    value: 'cosmetic'
  },
  {
    label: t('Illness.ent'),
    icon: Ent,
    value: 'ent'
  },
  {
    label: t('Illness.eye'),
    icon: Eye,
    value: 'eye'
  },
  {
    label: t('Illness.hair'),
    icon: Hair,
    value: 'hair'
  },
  {
    label: t('Illness.heart'),
    icon: Heart,
    value: 'heart'
  },
  {
    label: t('Illness.prostatitis'),
    icon: Hernia,
    value: 'prostatitis'
  },
  {
    label: t('Illness.fertility'),
    icon: Fetus,
    value: 'fertility'
  },
  {
    label: t('Illness.intestine'),
    icon: Intestine,
    value: 'intestine'
  },
  {
    label: t('Illness.kidney'),
    icon: Kidney,
    value: 'kidney'
  },
  {
    label: t('Illness.otho'),
    icon: Ortho,
    value: 'ortho'
  },
  { label: t('Illness.liver'), icon: Liver, value: 'liver' },
  { label: t('Illness.lungs'), icon: Lungs, value: 'lungs' },
  { label: t('Illness.obesity'), icon: Fat, value: 'obesity' },
  { label: t('Illness.spine'), icon: Spine, value: 'spine' },
  { label: t('Illness.unknown'), icon: Unknown, value: 'unknown' }
];

// export const IllnessValue = {
//   brain: 'Brain & Neuro',
//   bone_marrow: 'Bone Marrow',
//   cancer: 'Cancer',
//   corona_virus: 'Corona Virus',
//   ent: 'ENT',
//   eye: 'Eye',
//   hair_consmetics: 'Hair and Cosmetics',
//   heart: 'Heart',
//   hernia_related: 'Hernia and other related',
//   fertility: 'Infertility',
//   intestine: 'Intestine',
//   kidney: 'Kidney',
//   knee_hip_shoulder: 'Knee, Hips and Shoulder',
//   liver: 'Liver',
//   lungs: 'Lungs',
//   obesity: 'Obesity',
//   spine: 'Spine',
//   unknown: 'others or select unknown',
//   '': 'others or select unknown'
// };
